import React, { FC } from 'react';
import { ProDetailList, ProText } from '@bedrock/eed-react';
import { FormItemBaseFile, SupplierDetailList } from '@purchase/supplier';
import { ProCustomFieldDate } from '../../components/ProCustomFieldDate';

export const SupplierAwardsSection: FC = () => {
  return (
    <SupplierDetailList
      name={['extendAttributeInfo', 'industryAwards']}
      fieldProps={{ scroll: { x: 1120 } }}
    >
      <ProDetailList.Item
        label="#"
        name="#"
        meta={{ columnProps: { width: 50, fixed: true } }}
      >
        {(_, __, index) => index + 1}
      </ProDetailList.Item>
      <ProDetailList.Item
        label="奖项名称"
        name="awardName"
        meta={{
          columnProps: { width: 200, className: 'font-semibold', fixed: true },
        }}
      >
        <ProText />
      </ProDetailList.Item>
      <ProDetailList.Item label="获奖项目" name="awardProject">
        <ProText />
      </ProDetailList.Item>
      <ProDetailList.Item
        label="获奖时间"
        name="awardedAt"
        meta={{ columnProps: { width: 240 } }}
      >
        <ProCustomFieldDate />
      </ProDetailList.Item>
      <ProDetailList.Item
        label="获奖案例"
        name="winningCases"
        meta={{ columnProps: { width: 240 } }}
      >
        <FormItemBaseFile />
      </ProDetailList.Item>
    </SupplierDetailList>
  );
};
